var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAaplIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.9,541.3H91.2l69.5-201.4h54.9L285,541.3h-45.6L189,385.9h-1.6L136.9,541.3z M134,462.1h107.8v33.2H134 V462.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M334,541.3h-45.6l69.5-201.4h54.9l69.4,201.4h-45.6l-50.4-155.4h-1.6L334,541.3z M331.1,462.1h107.8v33.2 H331.1V462.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M496.4,541.3V339.9h79.5c15.3,0,28.3,2.9,39,8.7c10.8,5.8,19,13.8,24.6,24.1c5.7,10.3,8.5,22.1,8.5,35.5 c0,13.4-2.9,25.2-8.7,35.4c-5.8,10.2-14.1,18.2-25,23.9c-10.9,5.7-24.1,8.6-39.6,8.6h-50.6v-34.1h43.8c8.2,0,15-1.4,20.3-4.3 c5.3-2.9,9.3-6.8,12-11.9c2.7-5.1,4-10.9,4-17.6c0-6.7-1.3-12.5-4-17.6c-2.7-5-6.7-8.9-12-11.7c-5.4-2.8-12.2-4.2-20.5-4.2H539 v166.6H496.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M665.8,541.3V339.9h42.6v166.3h86.3v35.1H665.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaplIcon);
export default __webpack_public_path__ + "static/media/aapl_icon.6353a001cd4d4ae1341c9f10db171732.svg";
export { ForwardRef as ReactComponent };